import { render } from "./uploadPricesPopup.vue?vue&type=template&id=0ac54152&scoped=true"
import script from "./uploadPricesPopup.vue?vue&type=script&lang=js"
export * from "./uploadPricesPopup.vue?vue&type=script&lang=js"

import "./uploadPricesPopup.vue?vue&type=style&index=0&id=0ac54152&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac54152"]])

export default __exports__